export default __webpack_public_path__ + "static/media/bootstrap.63ab1545.svg";